module.exports = __webpack_public_path__ + "img/down.61716bf.png";